import { ProductInfo } from '../store/types';

export const getLocalProducts = (): ProductInfo[] => JSON.parse(localStorage.getItem('products') ?? '[]') as ProductInfo[];
export const setLocalProducts = (products: ProductInfo[]) => localStorage.setItem('products', JSON.stringify(products));
export const setLocalProduct = (product: ProductInfo) => {
  const localProducts = getLocalProducts();
  const updatetProducts =
    localProducts.map((localProduct) =>
      localProduct.name === product.name
        ? product
        : localProduct
    );
  setLocalProducts(updatetProducts);
};
